import Dropdown from 'bootstrap/js/dist/dropdown';

document.addEventListener('DOMContentLoaded', function(){

    // only for desktop
    if ( window.innerWidth < 1400 ) return;

    // get navbar
    const navbar = document.querySelector('#mainNavbar');

    // get dropdowns
    const dropdowns = navbar.querySelectorAll('.dropdown, .dropend');

    dropdowns.forEach(dropdown => {

        dropdown.addEventListener('mouseover', function(e){
            // show items when mouse enters
			let triggerEl = this.querySelector('[data-bs-toggle]');
            let bsInstance = Dropdown.getOrCreateInstance(triggerEl);

            bsInstance.show();
        });

        
        dropdown.addEventListener('mouseleave', function(e){
            // hide items when mouse leaves
			let triggerEl = this.querySelector('[data-bs-toggle]');
            let bsInstance = Dropdown.getOrCreateInstance(triggerEl);

            bsInstance.hide();
        });

    });

});